/** Hindi: getting in and finding: language choice, sign-in, the menu, Find, My card, the job list. */
export const screens = {
    "onboard.title": "अपनी भाषा चुनें",
    "onboard.later": "इसे बाद में “मेरे बारे में” में बदला जा सकता है।",
    "onboard.continue": "आगे बढ़ें",
    "signin.label": "साइन इन",
    "signin.headline": "आपका एजेंट, आपका फ़ोन।",
    "signin.soft": "आपका नंबर आपका ही रहता है।",
    "signin.consumer": "मुझे काम करवाना है",
    "signin.worker": "मुझे काम चाहिए",
    "signin.language": "भाषा: {lang}",
    "signin.change": "बदलें",
    "signin.name": "आपका नाम",
    "signin.phone": "मोबाइल नंबर",
    "signin.err_phone": "अपना 10 अंकों का मोबाइल नंबर लिखें।",
    "signin.code": "एसएमएस में आया कोड",
    "signin.code_dev": "एसएमएस में आया कोड (डेव: {code})",
    "signin.send_code": "कोड भेजें",
    "signin.submit": "साइन इन करें",
    "role.worker": "कामगार",
    "role.customer": "ग्राहक",
    "nav.find": "खोजें",
    "nav.my_jobs": "मेरे काम",
    "nav.card": "मेरा कार्ड",
    "shell.sign_out": "साइन आउट",
    "trail.to_decide": "{count} पर फ़ैसला बाकी",
    "find.headline": "आपके आस-पास कौन मदद कर सकता है।",
    "find.soft": "आपका बजट इसी फ़ोन पर रहता है।",
    "find.area": "इलाक़ा",
    "find.within_km": "{km} किमी के अंदर",
    "find.distance": "{km} किमी",
    "find.from": "{price} से",
    "find.when": "कब",
    "find.ask.one": "{count} कामगार से पूछें",
    "find.ask.other": "{count} कामगारों से पूछें",
    "card.headline": "लोग आपको ढूँढ सकें।",
    "card.soft": "आपका सबसे कम दाम इसी फ़ोन पर रहता है।",
    "card.what": "मेरा काम",
    "card.where": "काम का इलाक़ा",
    "card.rate": "आम दाम, ₹ (बोर्ड पर दिखेगा)",
    "card.min": "मेरा सबसे कम दाम, ₹ (निजी)",
    "card.about": "मेरे काम के बारे में",
    "card.about_example": "10 साल, वायरिंग और पंखे",
    "card.languages": "मेरी भाषाएँ",
    "card.ask_first": "{item} हों तो दाम बताने से पहले मुझसे पूछें",
    "card.auto": "मेरे दामों के अंदर एजेंट ख़ुद सौदा पक्का कर दे",
    "card.band_use": "आपका एजेंट हर काम का दाम इसी रेंज से तय करता है और आपके सबसे कम दाम से नीचे कभी नहीं जाता।",
    "card.on_board": "बोर्ड पर: {area} में {trades}, {price} से",
    "card.off_board": "बोर्ड से हटा दिया",
    "card.publish": "मेरा कार्ड लगाएँ",
    "card.unlist": "मेरा कार्ड बोर्ड से हटाएँ",
    "card.err_trade": "कम से कम एक काम चुनें, या अपना काम जोड़ें।",
    "card.err_rate": "आम दाम आपके सबसे कम दाम से कम नहीं हो सकता।",
    "requests.checked": "{time} पर देखा",
    "error.generic": "कुछ गड़बड़ हो गई। फिर से कोशिश करें।",
    "a11y.deal": "सौदा",
    "a11y.contact": "संपर्क",
    "a11y.notes": "संदेश",
    "a11y.payment": "भुगतान",
    "a11y.plan": "प्लान",
    "a11y.approve": "रिक्वेस्ट मंज़ूर करें",
    "a11y.answer": "कामगार को जवाब दें",
    "a11y.sign": "सौदे पर दस्तख़त करें",
    "a11y.confirm_payment": "भुगतान पक्का करें",
    "a11y.pay": "भुगतान करें",
    "a11y.review": "राय",
    "a11y.stars": "सितारे",
    "a11y.review_text": "राय का संदेश",
    "a11y.utr": "यूपीआई रेफ़रेंस",
    "a11y.qr": "यूपीआई क्यूआर कोड",
    "a11y.job_with": "{name} के साथ काम",
    "a11y.worker": "कामगार {name}",
    "a11y.ask_worker": "{name} से पूछें",
    "a11y.ask_workers": "कामगारों से पूछें",
    "a11y.my_card": "मेरा कार्ड",
    "a11y.role": "भूमिका",
    "a11y.language": "भाषा",
    "a11y.note": "ग्राहक के लिए संदेश",
    "a11y.send": "भेजें",
};
//# sourceMappingURL=screens.js.map